(function () {
  $(document).ready(function () {
    $(document).on('swell:initialized', function () {
      swellCampaignsList();
      removeLoader("campaign");
      swellRedemptionList();
      removeLoader("redemption");
    });
    $(document).on('swell:setup', function () {
      $(".swell-post-checkout").css("display", "flex");
      $(".swell-post-checkout .swell-referral-back-link").click(function(){
        $(".swell-post-checkout").css("display","none");
      });
      SwellConfig.Tier.initializeDummyTier();
      SwellConfig.Tier.initializeCustomTierProperties();
      SwellConfig.Tier.initializeTiers(".swell-tier-table");
      SwellConfig.Tier.setupSlickSlider();
      removeLoader("tiers");
    });
    initializeLinks(".swell-sign-up");
    $("body").on("click", ".swell-redemption-option-content.recharge", function () {
      if (spapi.authenticated) {
        var redemptionId = $(this).attr("data-redemption-option-id");
        redemptionId = parseInt(redemptionId);
        var redemptionCoupon = spapi.findActiveRedemptionOptionById(redemptionId);
        swellAPI.refreshCustomerDetails();
        if (spapi.customer.adjusted_points_balance < redemptionCoupon.amount) {
          $("#swell-reward-heading").html("Oops!");
          $("#swell-reward-intro").html("Sorry, you don't have enough points for this reward.");
          $("#swell-redemption-error").css("display", "none");
          $(".swell-modal").css("display", "flex");
        }
        else {
          var onRedemptionSuccess = function (redemption) {
            $("#swell-reward-heading").html(redemption.redemptionOption.name);
            $("#swell-coupon-intro").html(redemption.redemptionOption.description);
            $("#swell-reward-intro").html(redemption.redemptionOption.reward_intro);
            $("#swell-coupon-code").html(redemption.couponCode);
            $("#swell-redemption-error").css("display", "none");
            $(".swell-modal").css("display", "flex");
          }
          var onError = function (err) {
            $("#swell-reward-heading").html("Oops!");
            $("#swell-reward-intro").html("Sorry, either you have a coupon already applied to your subscription, or you do not have an existing subscription.");
            $("#swell-redemption-error").css("display", "none");
            $(".swell-modal").css("display", "flex");
          }
          swellAPI.makeRedemption({
            redemptionOptionId: redemptionId
          }, onRedemptionSuccess, onError);
        }
      }
    });
    $('body').on('click', ".swell-model-close", function () {
      $(".swell-modal").hide();
    });
    $("body").on("click", ".checkout-heading .swell-referral-back-link", function () {
      $(".swell-post-checkout").css("display", "none");
    });
  });
}).call(this);
function swellCampaignsList() {
  var campaigns = spapi.activeCampaigns;
  campaigns.forEach(function (campaign) {
    if (campaign.type != "ReferralCampaign") {
      $('.swell-campaign-list').append("<li class='swell-campaign'> <div class='swell-campaign-content campaign-list swell-campaign-link' data-display-mode='modal' data-campaign-id='" + campaign.id + "'> <div class='swell-campaign-icon'> <span class='swell-campaign-icon-content'> <i class='" + campaign.icon + "'> </i> </span> </div> <div class='swell-campaign-value'> <span class='swell-campaign-value-content'>" + campaign.reward_text + "</span> </div> <div class='swell-campaign-type'> <span class='swell-campaign-type-content'>" + campaign.title + "</span> </div> </div> </li>");
    }
  });
};
function swellRedemptionList() {
  var redemptions = spapi.activeRedemptionOptions;
  redemptions.forEach(function (redemption) {
    if (redemption.discount_type == "shopify_recharge_fixed_amount") {
      $('.swell-redemption-option-list-shopify').append('<li class="redemption swell-redemption-option"> <div class="swell-redemption-option-content swell-redemption-link redemption-content" data-redemption-option-id="' + redemption.id + '"> <div class="swell-redemption-option-details"> <div class="swell-redemption-option-value">' + redemption.amount + ' Tokens</div> <div class="swell-redemption-option-cost">' + redemption.name + '</div> <div class="swell-redemption-option-cart-min">£' + (redemption.cart_greater_than_cents) / 100 + ' Minimum</div> </div> </div> </li>');
    }
    if (redemption.discount_type == "recharge_discount_fixed_amount") {
      $('.swell-redemption-option-list-recharge').append('<li class="redemption swell-redemption-option"> <div class="swell-redemption-option-content redemption-content recharge" data-redemption-option-id="' + redemption.id + '"> <div class="swell-redemption-option-details"> <div class="swell-redemption-option-value">' + redemption.cost_text + '</div> <div class="swell-redemption-option-cost">' + redemption.name + '</div> </div> </div> </li>');
    }
  });
};
(function () {
  window.SwellConfig = window.SwellConfig || {};
  SwellConfig.Tier = {
    getCustomerTierRank: function () {
      var customer_tier, intro_tier, rank, tiers;
      customer_tier = spapi.customer.vip_tier;
      tiers = spapi.activeVipTiers;
      if (customer_tier && customer_tier.id) {
        rank = jQuery.grep(tiers, function (e) {
          return e.id === customer_tier.id;
        })[0].rank;
        return rank;
      }
      else {
        intro_tier = jQuery.grep(tiers, function (e) {
          return e.swellrequiredAmountSpent === "$0" && e.swellrequiredAmountSpentCents === 0 && e.swellrequiredPointsEarned === 0 && e.swellrequiredPurchasesMade === 0 && e.swellrequiredReferralsCompleted === 0;
        });
        if (intro_tier.length > 0) {
          return intro_tier[0].rank;
        }
        else {
          return null;
        }
      }
    },
    getCustomerTierId: function () {
      var customer_tier, intro_tier, tiers;
      customer_tier = spapi.customer.vip_tier;
      tiers = spapi.activeVipTiers;
      if (customer_tier) {
        return customer_tier.id;
      }
      else {
        intro_tier = jQuery.grep(tiers, function (e) {
          return e.swellrequiredAmountSpent === "$0" && e.swellrequiredAmountSpentCents === 0 && e.swellrequiredPointsEarned === 0 && e.swellrequiredPurchasesMade === 0 && e.swellrequiredReferralsCompleted === 0;
        });
        if (intro_tier.length > 0) {
          return intro_tier[0].id;
        }
        else {
          return null;
        }
      }
    },
    getTierByRank: function (rank) {
      var tiers;
      tiers = spapi.activeVipTiers;
      return jQuery.grep(tiers, function (e) {
        return e.rank === rank;
      })[0];
    },
    initializeDummyTier: function () {
      var k, len, tier, tiers;
      tiers = spapi.activeVipTiers;
      for (k = 0, len = tiers.length; k < len; k++) {
        tier = tiers[k];
        tier.rank += 1;
      }
      return tiers.unshift({
        id: -1,
        rank: 0,
        tierlevel: "Level 1",
        spendPoints: "",
        namePoints: "Bronze",
        benefit1: "1x",
        benefit2: "",
        benefit3: "",
        swellrequiredAmountSpentCents: 0,
        swellrequiredPointsEarned: 0,
        swellrequiredPurchasesMade: 0,
        swellrequiredReferralsCompleted: 0
      });
    },
    initializeCustomTierProperties: function () {
      let swellTickUrl = $('#swell-tick-img').attr('src');

      spapi.activeVipTiers[1].tierlevel = "Level 2",
      spapi.activeVipTiers[1].spendPoints = (convertNumber(spapi.activeVipTiers[1].points_earned)) + " Tokens Earned",
      spapi.activeVipTiers[1].namePoints = spapi.activeVipTiers[1].name,
      spapi.activeVipTiers[1].benefit1 = "1.25x",
      spapi.activeVipTiers[1].benefit2 = `<img src=${swellTickUrl}>`,
      spapi.activeVipTiers[1].benefit3 = "",

      spapi.activeVipTiers[2].tierlevel = "Level 3",
      spapi.activeVipTiers[2].spendPoints = (convertNumber(spapi.activeVipTiers[2].points_earned)) + " Tokens Earned",
      spapi.activeVipTiers[2].namePoints = spapi.activeVipTiers[2].name,
      spapi.activeVipTiers[2].benefit1 = "1.5x",
      spapi.activeVipTiers[2].benefit2 = `<img src=${swellTickUrl}>`,
      spapi.activeVipTiers[2].benefit3 = `<img src=${swellTickUrl}>`,

      spapi.activeVipTiers[3].tierlevel = "Level 4",
      spapi.activeVipTiers[3].spendPoints = (convertNumber(spapi.activeVipTiers[3].points_earned)) + " Tokens Earned",
      spapi.activeVipTiers[3].namePoints = spapi.activeVipTiers[3].name,
      spapi.activeVipTiers[3].benefit1 = "2x",
      spapi.activeVipTiers[3].benefit2 = `<img src=${swellTickUrl}>`,
      spapi.activeVipTiers[3].benefit3 = `<img src=${swellTickUrl}>`
    },
    initializeTiers: function (containerSelector) {
      var count = 1;
      tiers = spapi.activeVipTiers;
      $(containerSelector).append('<li class="titles-col"> <span class="name-item">Benefits</span> <span class="list-point-one">Point Multiplier</span> <span class="list-point-two">Branded Merchandise</span> <span class="list-point-three">Exclusive Events</span> </li>');
      $(containerSelector).append("<li class='tier-holder'></li>");
      tiers.forEach(function (tier) {
        $(".tier-holder").append("<div data-tier-id=" + tier.id + " class = 'tier-" + count + "-col tier-list-item'> <span class='points-holder'> <span class='tier-level'>" + tier.tierlevel + "</span><span class='name-item'>" + tier.namePoints + "</span> <span class='points-item'>" + tier.spendPoints + "</span> </span> <span>" + tier.benefit1 + "</span> <span>" + tier.benefit2 + "</span> <span>" + tier.benefit3 + "</span> </div>");
        count++;
      });
      if (spapi.authenticated) {
        SwellConfig.Tier.setupCustomerTierStatus();
      }
    },
    setupCustomerTierStatus: function () {
      var toGoNext, next_tier;
      var last_tier = spapi.activeVipTiers.length;
      var last_tier_rank = SwellConfig.Tier.getTierByRank(last_tier - 1);
      $(".swell-tier-table .titles-col, .swell-tier-table .tier-holder .tier-list-item").prepend("<div class='current-status'></div>");
      if (spapi.customer.vip_tier) {
        var $customer_tier_id, $customer_tier_rank;
        customer_tier_id = SwellConfig.Tier.getCustomerTierId();
        customer_tier_rank = SwellConfig.Tier.getCustomerTierRank();
        tiers = spapi.activeVipTiers;
        tiers.forEach(function (tier) {
          if (tier.id == customer_tier_id) {
            customer_tier = tier;
          }
        });
        if (last_tier_rank.rank == customer_tier_rank) {
          tiers.forEach(function (tier) {
            if (tier.rank == customer_tier.rank) {
              $("div[data-tier-id='" + tier.id + "'] .current-status").append("Current Status");
              $("div[data-tier-id='" + tier.id + "']").addClass("swell-active");

            }
          });
        }
        else {
          next_tier = SwellConfig.Tier.getTierByRank(customer_tier_rank + 1);
          toGoNext = next_tier.points_earned - spapi.customer.vip_tier_stats.points_earned;
          if (toGoNext < 0) {
            toGoNext = 0;
          }
          tiers.forEach(function (tier) {
            if (tier.rank == customer_tier.rank) {
              $("div[data-tier-id='" + tier.id + "'] .current-status").append("Current Status");
              $("div[data-tier-id='" + next_tier.id + "'] .current-status").append("<div class='spend_more'>Earn " + convertNumber(toGoNext) + " more tokens to earn " + next_tier.name + "</div>");
              $("div[data-tier-id='" + tier.id + "']").addClass("swell-active");

            }
          });
        }
      }
      else {
        next_tier = SwellConfig.Tier.getTierByRank(1);
        toGoNext = next_tier.points_earned - spapi.customer.vip_tier_stats.points_earned;
        if (toGoNext < 0) {
          toGoNext = 0;
        }
        $("div[data-tier-id='-1'] .current-status").append("Current Status");
        $("div[data-tier-id='" + next_tier.id + "'] .current-status").append("<div class='spend_more'>Earn " + convertNumber(toGoNext) + " more tokens to earn " + next_tier.name + "</div>");
        $("div[data-tier-id='-1']").addClass("swell-active");
      }
    },
    setupSlickSlider: function () {
      $('.swell-tier-table .tier-holder').slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToScroll: 1,
        slidesToShow: 4,
        prevArrow: false,
        nextArrow: false,
        responsive: [{
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
          }
        }]
      });
    }
  }
}).call(this);
function initializeLinks(containerSelector) {
  return $(document).on("click", containerSelector, function (e) {
    var href;
    e.preventDefault();
    href = $(this).attr("href");
    localStorage.setItem("swell-location", "/pages/rewards");
    return window.location = href;
  });
}
function convertNumber(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
function removeLoader(section) {
  $(".swell-loader-spinner." + section).remove();
}
